import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'Does my child need a large space to train?',
    answer: 'No! FutWork drills are designed for small-space mastery. A 10×10 foot area — like a garage, backyard, or hallway — is all you need. Every drill is optimized for at-home training.',
  },
  {
    question: 'How is this different from YouTube tutorials?',
    answer: 'YouTube is a library. FutWork is a system. Every session is structured with progressive difficulty, tracked reps, timed intervals, and coach-verified completion. Your child\'s coach can see exactly what they\'ve done.',
  },
  {
    question: 'What age group is FutWork designed for?',
    answer: 'FutWork is built for youth athletes ages 6–18. Drills scale from beginner fundamentals to advanced ball mastery, with age-appropriate difficulty levels assigned by coaches.',
  },
  {
    question: 'Can my child\'s coach see their progress?',
    answer: 'Yes! That\'s a core feature. Coaches have a live dashboard showing every session, rep, and completion. They can assign specific training homework and track who\'s putting in the work.',
  },
  {
    question: 'Is there a cost to use FutWork?',
    answer: 'FutWork is provided through your child\'s club. If your club is partnered with FutWork, your child gets full access. Ask your coach or club director for details.',
  },
  {
    question: 'What about Soccer IQ — the tactical training?',
    answer: 'Soccer IQ is our AI-powered tactical decision-making module. Players watch game scenarios unfold, then make real-time decisions under pressure. It trains the brain to read the pitch — not just the feet.',
  },
];

export function ParentFAQSection() {
  return (
    <section className="py-12 md:py-20 bg-background">
      <div className="max-w-2xl mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium mb-3">
            Parent FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-2">
            Questions? We've Got Answers.
          </h2>
          <p className="text-muted-foreground text-sm md:text-base">
            Everything parents need to know about FutWork
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="border-border/50">
              <AccordionTrigger className="text-left text-sm md:text-base font-medium hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
